module.exports = __webpack_public_path__ + "assets/img/ad53b76909f46e513d0adff2d861c196.png";